import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const assignFeatureToPermissions = async (id, updatedPermissions) => {
  try {
    const response = await apiClient.put(
      `/groups/assignPermissionsToGroup/${id}`,
      updatedPermissions
    );

    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
